import React, { useEffect, useMemo } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { followerRangePlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { useSetRangeDefaultValue } from '../../hooks/init';
import useLanguage from '@op/hooks/useLanguage';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { arrayToSimpleObj } from '@op/utils';

export default function FollowerRange({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  const { formatMessage, formatOptionsMessage } = useLanguage();

  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'followers',
      oriDefaultFilter,
      backOriDefaultValue,
      options: [
        { value: '-', text: 'All' },
        { value: '1-500000000', text: '1K+' },
        { value: '0-1', text: 'Common(0K ~ 1K)' },
        { value: '1-10', text: 'Nano(1K ~ 10K)' },
        { value: '10-50', text: 'Micro(10k ~ 50k)' },
        { value: '50-500', text: 'Mid-Tier(50k ~ 500k)' },
        { value: '500-1000', text: 'Macro(500k ~ 1M)' },
        { value: '1000-500000000', text: 'Mega(1M+)' },
      ],
    });
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start_followers, end_followers] = rangeValue.split('-');
      let dataItem: { start_followers: number; end_followers?: number } = {
        start_followers: Number(start_followers) * 1000,
      };
      if (end_followers !== '') {
        dataItem['end_followers'] = Number(end_followers) * 1000;
      }
      data.push(dataItem);
    }

    onChange?.(
      'followerRange',
      commonBackInfo({ followers: data }, { followerRange: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  // const { rangeValue, setRangeValue, followerRef, options } =
  //   useSetRangeDefaultValue({
  //     defaultValue,
  //     filterValue,
  //     defaultKey: 'followerRange',
  //     options: [
  //       { value: '-', text: 'All' },
  //       { value: '1-500000000', text: '1K+' },
  //       { value: '0-1', text: 'Common(0K ~ 1K)' },
  //       { value: '1-10', text: 'Nano(1K ~ 10K)' },
  //       { value: '10-50', text: 'Micro(10k ~ 50k)' },
  //       { value: '50-500', text: 'Mid-Tier(50k ~ 500k)' },
  //       { value: '500-1000', text: 'Macro(500k ~ 1M)' },
  //       { value: '1000-500000000', text: 'Mega(1M+)' },
  //     ],
  //     dealwithDateFunc: (value, key) => {
  //       // 那就是第一次进入，否则就是后面重新进入
  //       let realValue =
  //         Object.keys(filterValue).length === 0 ? value : filterValue;

  //       let start = realValue.start_follower / 1000;
  //       let end = realValue.end_follower / 1000;

  //       if (isNaN(start) || isNaN(end)) {
  //         return { value: '-' };
  //       }

  //       return {
  //         value: [start, end].join('-'),
  //         optionText: `${start}K ~ ${end}K`,
  //       };
  //     },
  //   });

  // useEffect(() => {
  //   const showHeader = followerRef.current?.buttonElement?.(rangeValue);
  //   const value = rangeValue === '-' ? false : rangeValue.split('-');

  //   onChange?.(
  //     'followerRange',
  //     commonBackInfo(
  //       value === false
  //         ? { start_follower: undefined, end_follower: undefined }
  //         : {
  //             start_follower: Number(value[0]) * 1000,
  //             end_follower: Number(value[1]) * 1000,
  //           },
  //       { followerRange: showHeader },
  //     ),
  //   );
  // }, [rangeValue, formatMessage]);

  const realOptions = useMemo(() => {
    return formatOptionsMessage(options);
  }, [options, formatMessage]);

  function getBackPoint(value: string) {
    const pointMap = arrayToSimpleObj(options);
    if (pointMap[value]) {
      return pointMap[value];
    }

    const [start, end] = value.split('-');

    return `${start}K ~ ${end}K`;
  }

  return (
    <div className={`dbo-follower-range-wrapper ${diffClassName}`}>
      <CustomFollowerRange
        lang={lang}
        ref={followerRef}
        options={realOptions}
        setRangeValue={setRangeValue}
        rangeValue={rangeValue}
        placeholder={followerRangePlaceholder}
        pointKey={FilterButtonPoint.followerRange}
        getBackPoint={getBackPoint}
      ></CustomFollowerRange>
    </div>
  );
}
